import { render, staticRenderFns } from "./editAboutWe.vue?vue&type=template&id=e3d85ecc&scoped=true&"
import script from "./editAboutWe.vue?vue&type=script&lang=js&"
export * from "./editAboutWe.vue?vue&type=script&lang=js&"
import style0 from "./editAboutWe.vue?vue&type=style&index=0&id=e3d85ecc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d85ecc",
  null
  
)

export default component.exports